import React, { useEffect, useState } from 'react';
import PageLayout from '../components/PageLayout';
import PageBanner from '../components/PageBanner';
import SEO from '../components/SEO';
import API from '../api';
import { useLanguage } from '../context/LanguageContext';

const BASE = process.env.REACT_APP_API_URL?.replace('/api', '') ?? 'http://localhost:5000';

export default function Clients() {
  const { t } = useLanguage();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/clients').then(r => setClients(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const imgSrc = (url) => url?.startsWith('/') ? `${BASE}${url}` : url;

  return (
    <PageLayout contactCta={false}>
      <SEO title={t('common.clients')} description="Sankyo Machine Tools' client and partner companies in the Philippines." />
      <PageBanner en="OUR CLIENTS" title={t('clients.title')} breadcrumbs={[{ label: t('common.clients') }]} />

      <section className="pt-6 pb-20 lg:pb-28 bg-white">
        <div className="w-[90%] max-w-7xl mx-auto">
          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px">
              {Array.from({ length: 8 }).map((_, i) => <div key={i} className="h-48 bg-gray-100 animate-pulse" />)}
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-t border-l border-gray-200">
              {clients.map((c, i) => (
                <div key={c.id} className="border-r border-b border-gray-200 p-6 sm:p-8 flex flex-col items-center gap-4 group fade-up hover:bg-[#f5f5f5] transition-colors"
                  style={{ animationDelay: `${i * 0.06}s` }}>
                  <div className="h-20 w-full flex items-center justify-center">
                    {c.logo_url ? (
                      <img src={imgSrc(c.logo_url)} alt={c.name}
                        className="max-h-16 max-w-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300" />
                    ) : (
                      <span className="font-bold text-charcoal text-center text-sm">{c.name}</span>
                    )}
                  </div>
                  <div className="text-center">
                    <h3 className="font-bold text-charcoal text-sm mb-1">{c.name}</h3>
                    {c.description && <p className="text-xs text-gray-500 line-clamp-2">{c.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </PageLayout>
  );
}
